"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var TableSelect = function TableSelect(_ref) {
  var checked = _ref.checked,
    id = _ref.id,
    row = _ref.row,
    selectType = _ref.selectType,
    _onClick = _ref.onClick;
  var input = _react["default"].createElement("div", {
    style: {
      textAlign: 'left'
    }
  }, _react["default"].createElement("input", {
    checked: checked || false,
    style: {
      marginTop: 0
    },
    type: selectType,
    onClick: function onClick(e) {
      var shiftKey = e.shiftKey;
      e.stopPropagation();
      _onClick(id, shiftKey, row);
    },
    onChange: function onChange() {}
  }));
  return input;
};
TableSelect.propTypes = {
  checked: _propTypes["default"].bool,
  id: _propTypes["default"].string,
  row: _propTypes["default"].objectOf(_propTypes["default"].any),
  selectType: _propTypes["default"].string,
  onClick: _propTypes["default"].func.isRequired
};
var _default = TableSelect;
exports["default"] = _default;